import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';

export const useProjectorLensStore = defineStore('projectorLens', () => {
  const {
    items: lenses,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroy,
  } = createBaseStore('api/library/projector-lens');

  const fetchGlobal = async () => {
    const overrideUrl = `/api/library/projector-lens?disguise_only=true`;
    return await fetch(null, overrideUrl);
  };

  const fetchSelf = async () => {
    const overrideUrl = `/api/library/projector-lens?self_only=true`;
    return await fetch(null, overrideUrl);
  };

  // Fetch multiple lenses by their IDs
  const fetchByIds = async (lensIds) => {
    if (!lensIds || lensIds.length === 0) return [];

    try {
      // Fetch each lens individually and return the results
      const lensPromises = lensIds.map((id) => fetch(id));
      const results = await Promise.all(lensPromises);
      return results.filter(Boolean); // Filter out any null results
    } catch (error) {
      console.error('Error fetching lenses by IDs:', error);
      return [];
    }
  };

  const fetchByProjector = async (projectorCode) => {
    if (!projectorCode) return [];

    try {
      const overrideUrl = `/api/library/projector-lens?projector=${projectorCode}`;

      const results = await fetch(null, overrideUrl);
      return results;
    } catch (error) {
      console.error('Error fetching lenses by projector code:', error);
      return [];
    }
  };

  return {
    lenses,
    fetch,
    destroy,
    update,
    store,
    fetchGlobal,
    fetchSelf,
    fetchByIds,
    fetchByProjector,
  };
});
